import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponsePatientType } from './types.ts'

const getPatientTypes = async <T>(

): Promise<FetchResponsePatientType<T>> => {
  let fetchResponse: FetchResponsePatientType<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>('/api/patient_types/')
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const patientTypesAPI = {
  getPatientTypes
}
